type DateKeys<T> = {
  [K in keyof T]: T[K] extends string | Date ? K : never;
}[keyof T];

export function sortByDate<T>(arr: T[], dateField: DateKeys<T>, order: 'asc' | 'desc'): T[] {
  return arr.toSorted((a, b) => {
    const toTime = (v: string | Date) =>
      typeof v === 'string' ? new Date(v).getTime() : v.getTime();

    const aTime = toTime(a[dateField] as string);
    const bTime = toTime(b[dateField] as string);
    return order === 'asc' ? aTime - bTime : bTime - aTime;
  });
}
